import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import ReactCardFlip from "react-card-flip";
import playSound from "@/sound";
import anime from "animejs/lib/anime.es.js";

const CardWrap = styled.div`
  width: 100%;
  height: 900px;
  margin-top: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const Card = styled.div`
  width: 895px;
  height: 580px;
  background-color: #fff;
  border-radius: 35px;
  font-size: 120px;
  color: #000;
  font-family: Noto Sans SC;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: width 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  > img {
    width: auto;
    height: 100%;
  }
  &.no-rotate {
    &:after {
      content: none;
    }
  }
  &:after {
    content: "";
    width: 132px;
    height: 156px;
    position: absolute;
    right: -37px;
    top: 35px;
    background: url(${require("@assets/img/icon_rotate.png")}) no-repeat;
  }

  &:before {
    content: "";
    width: 70px;
    height: 60px;
    left: 50px;
    top: 40px;
    position: absolute;
    background: url(${require("@assets/img/speaker_icon2.png")}) no-repeat;
  }
`;

const RotateButton = styled.button`
  width: 180px;
  height: 150px;
  position: absolute;
  right: 240px;
  top: 200px;
`;

const RotateCard = ({ img, cName, sound, direction, flipCard }) => {
  const [cardFront, setCardFront] = useState(img === "null");
  //curMode: "word2",
  const cardRef = useRef();
  const wordRef = useRef();

  const onClickCard = () => {
    playSound.word(sound);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    cardRef.current.rotateCard = (curWord, index = -1) => {
      wordRef.current.innerHTML = curWord;
      if (index > -1) {
        wordRef.current.setAttribute("data-current-idx", index);
      }

      setCardFront(true);

      anime({
        targets: wordRef.current,
        opacity: [0, 1],
        easing: "easeInOutCubic",
        duration: 400,
      });
    };

    cardRef.current.resetCard = (curWord) => {
      if (img === "null") {
        //setCardFront(false);
      } else {
        setCardFront(false);
      }

      if (curWord !== "_keep") {
        wordRef.current.innerHTML = curWord;
      }
    };
  }, []);

  useEffect(() => {
    const currentFlipedIndex = wordRef.current.getAttribute("data-current-idx");
    flipCard(cardFront, currentFlipedIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardFront]);

  useEffect(() => {
    wordRef.current.setAttribute("data-current-idx", 0);
  }, [img]);

  return (
    <CardWrap className={cName} ref={cardRef} onClick={onClickCard}>
      <ReactCardFlip
        isFlipped={cardFront}
        flipSpeedBackToFront={0.3}
        flipSpeedFrontToBack={0.3}
        flipDirection={direction}
      >
        <Card className={`card-box ${img === "null" && "no-rotate"}`}>
          {img !== "null" && <img src={img} alt="" />}
        </Card>
        <Card className={`card-box ${img === "null" && "no-rotate"}`}>
          <div ref={wordRef}></div>
        </Card>
      </ReactCardFlip>
      {img !== "null" && (
        <RotateButton
          type="button"
          className="rbtn"
          onClick={() => {
            //playSound.effect(cardFlipSound);
            // playSound.word(sound);
            setCardFront(!cardFront);
          }}
        />
      )}
    </CardWrap>
  );
};

export default RotateCard;
